const once = function (_el, _event, _fn, _opts) {
    var onceFn = function (_e) {
        _el.removeEventListener(_event, onceFn);
        _fn.apply(this, arguments);
    };
    _el.addEventListener(_event, onceFn, _opts);
    return onceFn;
};

export default once;
